import React, { Fragment, useMemo } from 'react';
import { selectTemplate, interpolateStaticVars, PLACEHOLDER_TOKEN } from '../whatsappTemplates';
import { MessagePreviewPlaceholder } from '../ResolveTicket.styles';

type WhatsappPreviewProps = {
  clientName: string;
  ticketId: string;
  agentComment: string;
  normalizedStatusName: string;
  hasFiles: boolean;
};

// Renders the WhatsApp message preview, interpolating the client name and ticket id and
// highlighting the agent comment (or a placeholder when it is still empty).
export function renderWhatsappPreview(
  template: string,
  vars: { clientName: string; ticketId: string; agentComment: string },
) {
  const withStaticVars = interpolateStaticVars(template, { clientName: vars.clientName, ticketId: vars.ticketId });
  const parts = withStaticVars.split(PLACEHOLDER_TOKEN);

  return parts.map((part, i) => (
    <Fragment key={i}>
      {part.split('\n').map((line, j, arr) => (
        <Fragment key={j}>
          {line}
          {j < arr.length - 1 && <br />}
        </Fragment>
      ))}
      {i < parts.length - 1 &&
        (vars.agentComment ? (
          <span>{vars.agentComment}</span>
        ) : (
          <MessagePreviewPlaceholder data-testid="comment-placeholder">{PLACEHOLDER_TOKEN}</MessagePreviewPlaceholder>
        ))}
    </Fragment>
  ));
}

function WhatsappPreview({ clientName, ticketId, agentComment, normalizedStatusName, hasFiles }: WhatsappPreviewProps) {
  const template = useMemo(() => selectTemplate(normalizedStatusName, hasFiles), [normalizedStatusName, hasFiles]);

  const content = useMemo(
    () => renderWhatsappPreview(template, { clientName, ticketId, agentComment }),
    [template, clientName, ticketId, agentComment],
  );

  return <>{content}</>;
}

export default WhatsappPreview;
